import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  isV2BankFlow,
  LocalizePropType,
  withTextLocalizer,
} from 'getaway-data-layer';

import '@adyen/adyen-web/styles/adyen.css';
import { isDashboardScreen, navigateTo, showAlert } from '../../../../../utils';
import SelectBankView from './SelectBankView';
import {
  getTruelayerAccounts,
  getTruelayerAuthLink,
  sendTruelayerCode,
} from 'getaway-data-layer/src/redux/store/userData/user/actions';
import { setTruelayerBankAccount } from 'getaway-data-layer/src/redux/store/ui/firstSteps/Actions';
import { useQuery } from '../../../../../hooks/useQuery';

type Props = {
  localize: LocalizePropType;
};

const SelectBankContainer = ({ localize }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();
  const [truelayerAccounts, setTruelayerAccounts] = useState([]);

  const truelayerCode = query.get('code');
  const isSelectingBanks = !!truelayerCode;

  const onClose = () => {
    if (truelayerCode) {
      query.delete('code');
      navigateTo(history, location.pathname, false);
    } else if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  const onPressBankSelection = () => {
    const baseUrl = window?.location?.origin;
    const path = isDashboardScreen()
      ? '/dashboard/selectBank'
      : '/onboarding/selectBank';
    const redirectUrl = `${baseUrl}${path}`;

    const encodedRedirectUrl = encodeURIComponent(redirectUrl);

    dispatch(
      getTruelayerAuthLink(encodedRedirectUrl, (response) => {
        if (response?.link) {
          window.location.href = response?.link;
        }
      })
    );
  };

  const onPressManual = () => {
    dispatch(setTruelayerBankAccount(null));
    navigateTo(
      history,
      `/${isDashboardScreen() ? 'dashboard' : 'onboarding'}/optimizedSepa`
    );
  };

  const onSelectAccount = (aacount: any) => {
    dispatch(setTruelayerBankAccount(aacount));
    navigateTo(
      history,
      `/${isDashboardScreen() ? 'dashboard' : 'onboarding'}/optimizedSepa`,
      false
    );
  };

  useEffect(() => {
    const truelayerCode = query.get('code');
    const truelayerError = query.get('error');

    if (isV2BankFlow() && truelayerAccounts?.length === 0 && !truelayerCode) {
      navigateTo(
        history,
        `/${isDashboardScreen() ? 'dashboard' : 'onboarding'}/optimizedSepa`,
        false
      );
    }

    if (truelayerError && truelayerCode) {
      query.delete('code');
      navigateTo(
        history,
        `/${isDashboardScreen() ? 'dashboard' : 'onboarding'}/optimizedSepa`,
        false
      );
    }
    if (truelayerCode) {
      dispatch(
        sendTruelayerCode(truelayerCode, () => {
          setTimeout(() => {
            dispatch(
              getTruelayerAccounts((res) => {
                if (res?.accounts) {
                  setTruelayerAccounts(res?.accounts);
                  if (res?.accounts.length === 1) {
                    dispatch(setTruelayerBankAccount(res?.accounts?.[0]));
                    navigateTo(
                      history,
                      `/${
                        isDashboardScreen() ? 'dashboard' : 'onboarding'
                      }/optimizedSepa`,
                      false
                    );
                  }
                }
              })
            );
          }, 1000);
        })
      );
    }
  }, []);
  return (
    <>
      <SelectBankView
        localize={localize}
        isSelectingBanks={isSelectingBanks}
        truelayerAccounts={truelayerAccounts}
        onSelectAccount={onSelectAccount}
        onClose={onClose}
        onPressBankSelection={onPressBankSelection}
        onPressManual={onPressManual}
      />
    </>
  );
};

export default withTextLocalizer(SelectBankContainer);
